var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MaterialTable from '../../MaterialTable';
import LabeledGridItem from '../../atoms/LabeledGridItem';
import OrderStatusTag from '../../atoms/OrderStatusTag';
import { camelize } from '../../../utils/camelize';
import { useBidActions, useBidColumns, useOrderItemColumns, } from '../../../hooks/useColumns';
import { usePaymentTimingForPriceVersion } from '../../../hooks/useListItem';
import OfferListLinks from '../../molecules/OfferListLinks';
import TransportToWarehouseStatus from '../../atoms/TransportToWarehouseStatus';
import { getStatus } from '../../atoms/OrderStatusTag';
import { StatusValues as TransportToWarehouseStatusValues } from '../../../constants/transportToWarehouseValues';
var GridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiGrid-root {\n    margin-bottom: 30px;\n  }\n\n  & .MuiTypography-body2 {\n    white-space: pre-wrap;\n  }\n"], ["\n  &.MuiGrid-root {\n    margin-bottom: 30px;\n  }\n\n  & .MuiTypography-body2 {\n    white-space: pre-wrap;\n  }\n"])));
var OrderContent = function (_a) {
    var loading = _a.loading, order = _a.order, orderItems = _a.orderItems, bids = _a.bids, _b = _a.isUSRoaster, isUSRoaster = _b === void 0 ? false : _b;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var OrderItemColumns = useOrderItemColumns({
        role: 'roaster',
        currency: order.roaster.country.currency,
    });
    var BidColumns = useBidColumns({ linkPrefix: '/roaster' });
    var BidActions = useBidActions({ role: 'roaster' });
    var paymentTimingForPriceVersion = usePaymentTimingForPriceVersion();
    var orderItemColumns = React.useMemo(function () { return [
        OrderItemColumns.lotNumber,
        OrderItemColumns.quantityWithWeight,
        OrderItemColumns.transportStatus,
        OrderItemColumns.transportToWarehouseNote,
        OrderItemColumns.transportToWarehouseTrackingUrl,
        OrderItemColumns.isPreOrderRequested,
        OrderItemColumns.comment,
        OrderItemColumns.roasterWarehouseItemsLink,
    ]; }, [OrderItemColumns]);
    var bidColumns = React.useMemo(function () { return [
        BidColumns.lotNumber,
        isUSRoaster ? BidColumns.fobPriceUsdPerLb : BidColumns.fobPrice,
        BidColumns.quantityWithWeight,
        BidColumns.buyPartial,
        BidColumns.bidAt,
        BidColumns.status,
    ]; }, [BidColumns, isUSRoaster]);
    var renderPaymentTiming = React.useMemo(function () {
        if (!order)
            return;
        return paymentTimingForPriceVersion(order);
    }, [paymentTimingForPriceVersion, order]);
    var renderOrderStatus = React.useMemo(function () {
        if (!order)
            return;
        var status = getStatus(order);
        if (!Array.isArray(status) &&
            TransportToWarehouseStatusValues.includes(status)) {
            return (React.createElement(TransportToWarehouseStatus, { transportToWarehouseStatus: status }));
        }
        return React.createElement(OrderStatusTag, { order: order });
    }, [order]);
    return (React.createElement("div", null,
        React.createElement(GridContainer, { container: true, spacing: 2 },
            React.createElement(LabeledGridItem, { label: t('params.offerList.name'), value: React.createElement(OfferListLinks, { pathPrefix: "/roaster", offerLists: order.offerLists }) }),
            React.createElement(LabeledGridItem, { label: t('params.order.status'), value: renderOrderStatus }),
            React.createElement(LabeledGridItem, { label: t('params.order.paymentTiming'), value: renderPaymentTiming }),
            React.createElement(LabeledGridItem, { label: t('params.order.deliveryMethod'), value: t("params.order.deliveryMethods.".concat(camelize(order.deliveryMethod))) }),
            order.deliveryMethod == 'split' && (React.createElement(LabeledGridItem, { label: t('params.order.deliveryComment'), value: order.deliveryComment })),
            React.createElement(LabeledGridItem, { label: t('params.order.billingName'), value: order.billingName }),
            React.createElement(LabeledGridItem, { label: t('params.order.storeName'), value: order.storeName }),
            React.createElement(LabeledGridItem, { label: t('params.order.personName'), value: order.personName }),
            i18n.language === 'ja' && (React.createElement(LabeledGridItem, { label: t('params.order.nameKana'), value: order.nameKana })),
            React.createElement(LabeledGridItem, { label: t('params.order.postalCode'), value: order.postalCode }),
            React.createElement(LabeledGridItem, { label: t('params.order.prefecture'), value: order.prefecture }),
            React.createElement(LabeledGridItem, { label: t('params.order.city'), value: order.city }),
            React.createElement(LabeledGridItem, { label: t('params.order.address'), value: order.address }),
            React.createElement(LabeledGridItem, { label: t('params.order.building'), value: order.building }),
            React.createElement(LabeledGridItem, { label: t('params.order.countryCallingCode'), value: order.countryCallingCode }),
            React.createElement(LabeledGridItem, { label: t('params.order.phone'), value: order.phone }),
            React.createElement(LabeledGridItem, { label: t('params.order.email'), value: order.email }),
            order.roaster.country.eoriNumberEnabled && (React.createElement(LabeledGridItem, { label: t('params.eoriNumber'), value: order.eoriNumber })),
            React.createElement(LabeledGridItem, { label: t('params.order.comment'), value: order.comment })),
        React.createElement(MaterialTable, { model: "orderItem", title: t('pages.orderDetail.orderItemsTableTitle'), isLoading: loading, columns: orderItemColumns, data: orderItems, options: {
                minBodyHeight: 0,
            } }),
        React.createElement(Box, { mt: 2 }),
        React.createElement(MaterialTable, { model: "bid", isLoading: loading, title: t('pages.orderDetail.bidsTableTitle'), columns: bidColumns, data: bids, actions: [BidActions.linkToAuction], options: {
                minBodyHeight: 0,
            } })));
};
export default OrderContent;
var templateObject_1;
